export const Endpoints = {
  RESET_PASSWORD: `${process.env.REACT_APP_SERVER_URL}/resetPassword`,
  RESEND_VERIFICATION_EMAIL: `${process.env.REACT_APP_SERVER_URL}/resendVerificationEmail`,
  TOKEN: `${process.env.REACT_APP_SERVER_URL}/token`,
  LOGOUT: `${process.env.REACT_APP_SERVER_URL}/logout`,
  IMAGE: `${process.env.REACT_APP_SERVER_URL}/image`,
  DOWNLOAD_EXPORT_LIST: `${process.env.REACT_APP_SERVER_URL}/download`,
};
